export const SET_RECOGNIZE_RESPONSE = 'SET_RECOGNIZE_RESPONSE'
export const SET_AWARD_HISTORY = 'SET_AWARD_HISTORY'
export const SET_NOMINATION_HISTORY = 'SET_NOMINATION_HISTORY'
export const SET_AWARD_CATEGORIES = 'SET_AWARD_CATEGORIES'
export const SET_POINT_DESCRIPTION = 'SET_POINT_DESCRIPTION'
